import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEvernoteComponent } from './simple-icons-evernote.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEvernoteComponent ],
    exports:      [ SimpleIconsEvernoteComponent ],
    bootstrap:    []
})
export class SimpleIconsEvernoteModule {}
